// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LabeledNode from '../../../../shared/components/labeled-node';
import LabeledString from '../../../../shared/components/labeled-string';
import {Link} from 'react-router';
import PipStatus from '../../../../product/shared/components/pip-status';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import SpaClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-summary';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {hasAccess} from '../../../../shared/services/security';

const linkTo = claimNumber =>
    `/tcsm/wip/spa/${claimNumber}`;

const showProcessComponent = security =>
    hasAccess(security, 'TCSM', 'TCSM_SPL_ALLOWANCE_PROCESS');

const SpaResult = (props, context) =>
    <section className='spa-result'>
        <header>
            <section className='spa-title'>
                {showProcessComponent(context.security) ?
                    <Link to={linkTo(props.claim.claimNumber)}>
                        <FormattedMessage
                            id='SPECIAL_ALLOWANCE_CLAIM_WITH_ID'
                            values={{
                                claimNumber: props.claim.claimNumber
                            }}
                        />
                    </Link> :
                    <FormattedMessage
                        id='SPECIAL_ALLOWANCE_CLAIM_WITH_ID'
                        values={{
                            claimNumber: props.claim.claimNumber
                        }}
                    />
                }
            </section>
            {props.claim.pipIndicator.status &&
                <section className='spa-pips'>
                    <PipStatus
                        pin={props.claim.pin}
                        pipIndicator={props.claim.pipIndicator}
                    />
                </section>
            }
        </header>
        <div className='spa-details'>
            <div className='row'>
                <LabeledString
                    className='reference1'
                    data={props.claim.reference1}
                    label='WORK_ORDER_ONE'
                />
                <LabeledNode
                    data={
                        <Link
                            className='pin'
                            rel='noopener noreferrer'
                            target='_blank'
                            to={`/products/${props.claim.pin}`}
                        >
                            {props.claim.pin}
                        </Link>
                    }
                    label='PIN'
                />
                <LabeledCurrency
                    className='customer-contribution'
                    data={props.claim.customerContribution}
                    label='CUSTOMER_CONTRIBUTION'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='status-value'
                    data={props.claim.status.value}
                    label='STATUS'
                />
                <LabeledString
                    className='submitted-date'
                    data={buildDate(props.claim.submittedDate)}
                    label='SUBMITTED'
                />
                <LabeledCurrency
                    className='dealer-contribution'
                    data={props.claim.dealerContribution}
                    label='DEALER_CONTRIBUTION'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='responsible-account lost-two-column'
                    data={buildDealer(props.claim.responsibleAccount)}
                    label='RESPONSIBLE_DEALER'
                />
                <LabeledCurrency
                    className='company-contribution'
                    data={props.claim.companyContribution}
                    label='COMPANY_CONTRIBUTION'
                />
            </div>
            <div className='row'>
                <LabeledString
                    className='created-by'
                    data={props.claim.recordInfo.createdBy.buildUserName()}
                    label='CREATED_BY'
                />
                <LabeledString
                    className='special-allowance-type-value lost-two-column'
                    data={props.claim.specialAllowanceType.value}
                    label='SPECIAL_ALLOWANCE_TYPE'
                />
            </div>
            {showProcessComponent(context.security) &&
                <footer>
                    <Link
                        className='button-primary'
                        to={linkTo(props.claim.claimNumber)}
                    >
                        <FormattedMessage id='VIEW_CLAIM'/>
                    </Link>
                </footer>
            }
        </div>
    </section>;

SpaResult.displayName = 'SpaResult';
SpaResult.propTypes = {
    claim: PropTypes.instanceOf(SpaClaimForApproval).isRequired
};
SpaResult.contextTypes = {
    security: PropTypes.instanceOf(Security).isRequired
};

export default SpaResult;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/special-allowance/spa-result.js